const nvl = (value) => (value ?? "").trim();

const participantKeyFromEntry = (entry) => {
  if (!entry.external && entry.id) return `c:${entry.id}`;
  const email = (entry.email || "").toLowerCase();
  const name = (entry.name || "").toLowerCase();
  return `e:${email}|${name}`;
};

const participantKeysFromAppointment = (appointment) => {
  const list = Array.isArray(appointment?.participants) ? appointment.participants : [];
  if (list.length) {
    return list
      .map((p) =>
        p.clientId
          ? `c:${p.clientId}`
          : `e:${(p.clientEmail || "").toLowerCase()}|${(p.clientName || "").toLowerCase()}`
      )
      .sort();
  }
  if (appointment?.clientId) return [`c:${appointment.clientId}`];
  return [
    `e:${(appointment?.clientEmail || "").toLowerCase()}|${(
      appointment?.clientName || ""
    ).toLowerCase()}`,
  ];
};

const participantKeysFromEntries = (entries) => [...entries.map(participantKeyFromEntry)].sort();

const keysEqual = (a, b) => a.length === b.length && a.every((key, index) => key === b[index]);

export const hasNotifyRelevantChanges = (originalAppointment, form, entries = []) => {
  if (!originalAppointment || !form) return false;

  if (nvl(originalAppointment.title) !== nvl(form.title)) return true;
  if (nvl(originalAppointment.description) !== nvl(form.description)) return true;
  if (nvl(originalAppointment.appointmentDate) !== nvl(form.appointmentDate)) return true;
  if (nvl(originalAppointment.appointmentTime) !== nvl(form.appointmentTime)) return true;
  if (nvl(originalAppointment.appointmentEndTime) !== nvl(form.appointmentEndTime)) return true;
  if (nvl(originalAppointment.location) !== nvl(form.location)) return true;
  if (nvl(originalAppointment.meetLink) !== nvl(form.meetLink)) return true;
  if (nvl(originalAppointment.fromEmail) !== nvl(form.fromEmail)) return true;
  if (nvl(originalAppointment.ccEmails) !== nvl(form.ccEmails)) return true;
  if ((originalAppointment.withUserId ?? null) !== (form.withUserId ?? null)) return true;

  return !keysEqual(
    participantKeysFromAppointment(originalAppointment),
    participantKeysFromEntries(entries)
  );
};

export const invalidateEmailLogQueries = (queryClient) => {
  queryClient.invalidateQueries(["client-email-logs"]);
  queryClient.invalidateQueries(["email-batches"]);
};
